<template>
    <li v-if="typeof node.fields.nodesList === 'undefined' || node.fields.nodesList.length === 0">
        <router-link 
          :to="{ name: 'single-category', params: { slug: node.fields.category.fields.slug } }"
          :class="{'node-active': activeNodes.includes(node.sys.id)}"
          class="underline_link">
          {{ node.fields.category.fields.title }}
        </router-link>
    </li>
    <ul v-else-if="node.sys.id === '7JBWTWGTBw454cKpn988Jk'">
        <node 
            v-for="(childNode, index) of node.fields.nodesList"
            :key="index"
            :node="childNode"
            :activeNodes="activeNodes" />
    </ul>
    <li v-else>
        <router-link 
          :to="{ name: 'single-category', params: { slug: node.fields.category.fields.slug } }"
          :class="{'node-active': activeNodes.includes(node.sys.id)}"
          class="underline_link">
            {{ node.fields.category.fields.title }}
        </router-link>
        <ul v-if="activeNodes.includes(node.sys.id)">
            <node 
                v-for="(childNode, index) of node.fields.nodesList"
                :key="index"
                :node="childNode"
                :activeNodes="activeNodes" />
        </ul>
    </li>
</template>

<script>
import Node from '@/components/Node/Node.vue'
export default {
  name: 'Node',
  components: {
    Node
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    activeNodes: {
      type: Array,
      default: []
    }
  }
}
</script>

<style lang="scss">
  .node-active{
    &:before{
      transform-origin: left center;
      transform: scale(1, 1);
      background: #000;
    }
  }
  .router-link-exact-active.node-active{
    &:before{
      transform-origin: left center;
      transform: scale(1, 1);
      background: #00D6B2;
    }
  }
</style>
